exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".edit:hover {\n  cursor: pointer;\n  text-decoration: underline; }\n", "", {"version":3,"sources":["/usr/src/app/src/components/Modals/Settings/SettingsViews/CemenView/CemenView.scss"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,2BAA2B,EAAE","file":"CemenView.scss","sourcesContent":[".edit:hover {\n  cursor: pointer;\n  text-decoration: underline; }\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"sourceMap":true,"minimize":false}!../~/postcss-loader?pack=sass!../~/sass-loader!./components/Modals/Settings/SettingsViews/CemenView/CemenView.scss
// module id = 2385
// module chunks = 0